/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice\src\Content\Modals\ModalPhone\ModalPhone.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice
 * Created Date: Tuesday September 10th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday September 10th 2024 3:51:11 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { MouseEventHandler, useEffect, useState } from "react";
import MyModal from "Content/Modals/MyModal";
import translator from "MultiLanguage/TranslationWrapper";
import styles from "Content/Modals/ModalPhone/ModalPhone.module.css";
import PhoneInput from "react-phone-number-input";
import { Button } from "@mui/material";
import ModalConfirmation from "../ModalConfirmation/ModalConfirmation";
import ContactService from "Services/Contact/ContactService";

type ModalCtaProps = {
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    themeColor: string,
};

export default function ModalPhone(props: ModalCtaProps) {
    const [phone, setPhone] = useState<string| undefined>(undefined);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [isSendable, setIsSendable] = useState(false);

    const handleCloseModals = (e: any) => {
        setOpenModal(false);
        props.closeModal(e);
    };

    useEffect(() => {
        if (phone)
            setIsSendable(true);
        else
            setIsSendable(false);
    }, [phone]);

    const HandleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (phone) {
            setIsSendable(false);
            ContactService.phoneCallBackRequest(phone).then(() => {
                setIsOkay(true);
                setOpenModal(true);
                setPhone(undefined);
            }).catch((error) => {
                console.error(error.message);
                setIsOkay(false);
                setOpenModal(true);
            });
        }
    };

    return (
        <>
            <MyModal closeModal={props.closeModal} show={props.show} onClose={props.onClose} addCloseCross={true} footer={<Button disabled={!isSendable} variant="contained" onClick={HandleSubmit}>{translator.decode("call_to_action.callBack")}</Button>} title={translator.decode("call_to_action.phoneContact")} className={styles.modalCtaStyle} themeColor={props.themeColor}>
                <PhoneInput autoComplete="on" value={phone} onChange={setPhone} defaultCountry={"FR"} />
                <span>{translator.decode("call_to_action.noSave")}</span>
            </MyModal>
            <ModalConfirmation show={openModal} onClose={handleCloseModals} closeModal={handleCloseModals} isOkay={isOkay} themeColor={""} />
        </>
    );
};
